/**
 * Builds conservative searchable text for unlinked-note mentions.
 * Explicit Markdown/wiki links, code and frontmatter are removed so existing
 * links are never double-counted as unlinked mentions.
 */
export function prepareUnlinkedMentionText(markdown: string): string {
  return markdown
    .replace(/^---\s*$[\s\S]*?^---\s*$/gmu, ' ')
    .replace(/```[\s\S]*?```/gu, ' ')
    .replace(/~~~[\s\S]*?~~~/gu, ' ')
    .replace(/`[^`\n]*`/gu, ' ')
    .replace(/!\[\[[^\]]*\]\]/gu, ' ')
    .replace(/\[\[[^\]]*\]\]/gu, ' ')
    .replace(/!\[[^\]]*\]\([^)]*\)/gu, ' ')
    .replace(/\[[^\]]+\]\([^)]*\)/gu, ' ')
    .replace(/<https?:\/\/[^>]+>/giu, ' ')
    .normalize('NFKC')
    .toLowerCase()
    .replace(/\s+/gu, ' ')
    .trim();
}

export function noteMentionLabel(filePath: string): string {
  const name = filePath.split('/').pop() || filePath;
  return name
    .replace(/\.(?:md|markdown)$/iu, '')
    .replace(/[-_]+/gu, ' ')
    .normalize('NFKC')
    .replace(/\s+/gu, ' ')
    .trim();
}

export function containsUnlinkedMention(preparedText: string, label: string): boolean {
  const normalized = label.normalize('NFKC').toLowerCase().replace(/\s+/gu, ' ').trim();
  if (normalized.length < 3 || !preparedText) return false;
  const escaped = normalized.replace(/[.*+?^${}()|[\]\\]/gu, '\\$&').replace(/\s+/gu, '\\s+');
  return new RegExp(`(?:^|[^\\p{L}\\p{N}])${escaped}(?=$|[^\\p{L}\\p{N}])`, 'u').test(preparedText);
}
